import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGame } from "../header/GameContext";
import { ANSWERS_DATA } from "./correctAnswerDatas";

const IS_QUIZ_CODE = [
  "code01",
  "time02",
  "time03",
  "trace4",
  "mind05",
  "file06",
  "lang07",
  "alarm8",
  "cross9",
]; //퀴즈가 있는 스테이지

function KeywordCheck({ onWrong, answerData }) {
  const { MISSION_TOTAL, clearedStages } = useGame();

  const [value, setValue] = useState("");
  const navigate = useNavigate();

  const KEYWORD_DATA = ANSWERS_DATA.keyword[0];
  const handleSubmit = () => {
    const key = value.trim().toLowerCase(); //입력 키워드
    const keywordInfo = KEYWORD_DATA[key]; //입력 키워드와 매칭되는 데이터
    const isPlace = keywordInfo?.type === "place";

    if (!KEYWORD_DATA[key]) {
      onWrong();
      return;
    }

    if (isPlace) {
      // console.log("keywordInfo", keywordInfo.content);
      // return;
      navigate("/place", {
        state: {
          DateVal: keywordInfo.content,
          titImgClass: "placeTit",
        },
      });
    } else {
      if (keywordInfo) {
        const stageKey = keywordInfo.answerData;

        // 중복 키워드(입장 제한)
        // if (clearedStages.has(stageKey)) {
        //   alert("다른 코드를 찾아보자");
        //   return;
        // }

        if (IS_QUIZ_CODE.includes(key)) {
          navigate("/quiz", {
            state: {
              answerData: stageKey,
              DateVal: keywordInfo.DateVal,
              titImgClass: keywordInfo.titImgClass,
              hintWhetherIs: keywordInfo.hintWhetherIs,
              hintContent: keywordInfo.hintContent,
            },
          });
        } else {
          // 단서 수집 미완료 시 최종 추론 접근 제한
          // if (key === "final0" && clearedStages.size < MISSION_TOTAL) {
          //   alert("다른 코드를 모두 진행해 주세요.");
          //   return;
          // }

          navigate("/info", {
            state: {
              DateVal: keywordInfo.DateVal,
              titImgClass: keywordInfo.titImgClass,
              timerMode: "run",
            },
          });
        }
      }
    }
  };
  return (
    <div className="mt24 mb40">
      <input
        className="input01"
        placeholder="키워드를 입력하세요."
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <button
        className={`inputBtn01 mt16 ${value.trim().length > 0 ? "active" : ""}`}
        onClick={handleSubmit}
      >
        입력 완료
      </button>
    </div>
  );
}

export default KeywordCheck;
